
import { Options, Vue } from "vue-class-component";
import MButton from "@/components/MButton.vue";
import { tutorPasswordState } from "@/api/tutorPassword";
import {
  daysUntilPasswordDeadline,
  formatDaysLeft,
  formatPasswordDeadline,
  TUTOR_PASSWORD_GUIDE_URL
} from "@/utils/tutorPasswordFormat";

/**
 * 期限前の先生にホームで出す、パスワード変更のお願い。
 * 変更が済むまで必ず目に入るよう、閉じるボタンは置かない。
 * スクールAIと同じく、白いカードに見出し・残り日数・説明の 2 行とボタンを並べる
 */
@Options({ components: { MButton } })
export default class TutorPasswordBanner extends Vue {
  guideUrl = TUTOR_PASSWORD_GUIDE_URL;
  get status() {
    return tutorPasswordState.status;
  }
  get deadline() {
    return this.status
      ? formatPasswordDeadline(this.status.requiredAt, Date.now())
      : "";
  }
  get daysLeft() {
    return this.status
      ? formatDaysLeft(
          daysUntilPasswordDeadline(this.status.requiredAt, Date.now())
        )
      : "";
  }
}
